import EditBonusPage from './EditBonusPage';

export default EditBonusPage;
